var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHouseSmall = function SvgHouseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 353,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 176.334V291h230V176.243L177.617 72.72 62 176.334zm-51.69-36.93L157.03 7.913c11.818-10.59 29.726-10.547 41.491.102l145.281 131.489A31 31 0 0 1 354 162.489V322c0 17.12-13.88 31-31 31H31c-17.12 0-31-13.88-31-31V162.489a31 31 0 0 1 10.31-23.086z"
  })));
};

export default SvgHouseSmall;